import React, { Component } from 'react';
import Header from './header.component.js';
import styled  from 'styled-components';
import pdf from '../images/pdf.svg';
import document from '../docs/KiTa_FöVe_Beitrittserklärung_2025.pdf';

const Background = styled.div`
    background-color:#f8f9fa !important; 
    border-radius:10px;
    padding: 10px;
    margin: 10px;
`;

const Quote = styled.div`
    font-style:italic;
    font-size:25px;
    padding:15px;
`;

const UnorderedList = styled.div`
    display:inline-block !important;
`;

class Join extends Component {
	constructor(props) {
  		super(props);
  		this.state = {
  		};
    }
      
	render() {
    	return (
            <div>
                <div className="container opacity90">
                    <Header text="Beitritt" />
                    <div className="row">
                        <div className="col-12 text-center">
                            <Background>
                                
                                <Quote>
                                    "Ein Verein lebt von seinen Mitgliedern und Spendern! 
                                    <br />
                                    Wir freuen uns auf Ihre Unterstützung."
                                </Quote>

                                Wir haben Ihr Interesse geweckt und auch Sie möchten unseren Verein und damit unsere Kinder unterstützen? 
                                Laden Sie sich hier unsere Beitrittserklärung herunter, füllen diese aus und wenden Sie sich an einen der folgenden Vorstandsmitglieder:
                                <br />
                                <UnorderedList>
                                    <li>Stefanie Moreth, 1. Vorsitzende</li>
                                    <li>Christian Langer, 2. Vorsitzender</li>
                                    <li>Alina Spee, Kassiererin</li>
                                </UnorderedList>
                                <br />
                                Wir bedanken uns für Ihre Unterstützung im Voraus.
                                <br />
                                <br />
                                <strong><a href={document} target="_blank" download>Download der Beitrittserklärung</a></strong>
                                <br />
                                <a href={document} target="_blank" download><img src={pdf} alt="PDF" className="height50px" /></a>
                            </Background>
                        </div>
                    </div>
                </div>
            </div>
    	);
  	}
}

export default Join;


// WEBPACK FOOTER //
// ./src/components/join.component.js